/**
 * @generated SignedSource<<0b8f94bfb5d6c47a20a026ceecda2ff2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SlackIntegrationAutoRespondMutation$variables = {
  enabled: boolean;
};
export type SlackIntegrationAutoRespondMutation$data = {
  readonly updateAutoRespondInThreads: {
    readonly error: {
      readonly message: string;
    } | null | undefined;
    readonly success: {
      readonly organization: {
        readonly autoRespondInThreads: boolean;
        readonly id: any;
      };
    } | null | undefined;
  };
};
export type SlackIntegrationAutoRespondMutation = {
  response: SlackIntegrationAutoRespondMutation$data;
  variables: SlackIntegrationAutoRespondMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "enabled"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "enabled",
        "variableName": "enabled"
      }
    ],
    "concreteType": "UpdateAutoRespondInThreadsResponse",
    "kind": "LinkedField",
    "name": "updateAutoRespondInThreads",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UpdateAutoRespondInThreadsSuccess",
        "kind": "LinkedField",
        "name": "success",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLOrganization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "autoRespondInThreads",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UpdateAutoRespondInThreadsError",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SlackIntegrationAutoRespondMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SlackIntegrationAutoRespondMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "356462bd6bb6d15d01c6114c7af3771c",
    "id": null,
    "metadata": {},
    "name": "SlackIntegrationAutoRespondMutation",
    "operationKind": "mutation",
    "text": "mutation SlackIntegrationAutoRespondMutation(\n  $enabled: Boolean!\n) {\n  updateAutoRespondInThreads(enabled: $enabled) {\n    success {\n      organization {\n        id\n        autoRespondInThreads\n      }\n    }\n    error {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a21edd7214e28a4bc1f49e60f81e1df7";

export default node;
